import Vue from 'vue'
const AWS = require('aws-sdk')
const axios = require('axios');
const generateHash = () => {
    //http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript
    return (
        Math.random().toString(36).substring(2, 15) +
        Math.random().toString(36).substring(2, 15)
    )
}

const state = {}

const mutations = {}

const actions = {
    s3upload(context, files) {


        console.log('files',files);
        return new Promise((resolve, reject) => {
            if (!files || !files.length) {
                return reject(new Error('No Files!'))
            }
            const credentials = context.rootState.js_report.aws_credentials
            if (!credentials) { return reject(new Error('Missing Storage Credentials!')) }

            const keys = files.map(() => {
                return generateHash(); // Generate a unique key for each file.
            });

            const {
                key: accessKeyId,
                secret: secretAccessKey,
                token: sessionToken,
                //key_path: Key,
                region,
                bucket: Bucket,
            } = credentials
            if (!accessKeyId || !secretAccessKey || !Bucket)
                return reject(new Error('Missing Storage Credentials!'))
            const options = {
                region,
                accessKeyId,
                secretAccessKey,
                sessionToken,
            }

            console.log('options', options)
            AWS.config.update(options)
            const s3 = new AWS.S3()

            const webdomain = context.rootGetters["web_domain"];
            const fileprefix = Vue.prototype.$MediaPrefix
            const { email } = context.rootState.user;
            
            const Metadata = {
                webdomain,
                fileprefix,
                email,
            }


            // upload multiple files
            for (let index = 0; index < files.length; index++) {
                // for(let file of files){
                const loadFile = Body => {
                    const params = {
                        Bucket,
                        Key: keys[index],
                        Body,
                        ContentType: files[index].type,
                        ContentDisposition: files[index].name,
                        Metadata: {
                            ...Metadata,
                            description: files[index].fileDescription || '', // Add the file description to Metadata
                        }
                    }
                    const options = { partSize: 10 * 1024 * 1024, queueSize: 1 };
                    console.log('s3Files params', params)
                    s3.upload(params, options, err => {
                        if (err) {
                            console.error('s3Files err', err)
                            return reject(err)
                        }
                        console.log('s3 keys', keys)
                        /////const keys = Key; //.map(x => `${fileprefix}/${x}`)
                        const name = files[index].name
                        return resolve({ keys, name })
                    })
                }

                const reader = new FileReader()

                reader.onload = () => {
                    const fileData = new Uint8Array(reader.result)
                    //const fileBson = new BSON.Binary(fileData)
                    loadFile(fileData)
                }
                reader.readAsArrayBuffer(files[index])
            }
        })
    },
    s3uploadOrder(context, files) {


        console.log('files',files);
        return new Promise((resolve, reject) => {
            if (!files || !files.length) {
                return reject(new Error('No Files!'))
            }
            const credentials = context.rootState.js_report.aws_credentials
            if (!credentials) { return reject(new Error('Missing Storage Credentials!')) }

            const keys = files.map(() => {
                return generateHash(); // Generate a unique key for each file.
            });

            const {
                key: accessKeyId,
                secret: secretAccessKey,
                token: sessionToken,
                //key_path: Key,
                region,
                bucket: Bucket,
            } = credentials
            if (!accessKeyId || !secretAccessKey || !Bucket)
                return reject(new Error('Missing Storage Credentials!'))
            const options = {
                region,
                accessKeyId,
                secretAccessKey,
                sessionToken,
            }

            console.log('options', options)
            AWS.config.update(options)
            const s3 = new AWS.S3()

            const webdomain = context.rootGetters["web_domain"];
            const fileprefix = Vue.prototype.$MediaPrefix
            const { email } = context.rootState.user;
            
            const Metadata = {
                webdomain,
                fileprefix,
                email,
            }


            // upload multiple files
            for (let index = 0; index < files.length; index++) {
                // for(let file of files){
                const loadFile = Body => {
                    const params = {
                        Bucket,
                        Key: keys[index],
                        Body,
                        ContentType: files[index].file.type,
                        ContentDisposition: files[index].file.name,
                        Metadata: {
                            ...Metadata,
                            description: files[index].file.fileDescription || '', // Add the file description to Metadata
                        }
                    }
                    const options = { partSize: 10 * 1024 * 1024, queueSize: 1 };
                    console.log('s3Files params', params)
                    s3.upload(params, options, err => {
                        if (err) {
                            console.error('s3Files err', err)
                            return reject(err)
                        }
                        console.log('s3 keys', keys)
                        /////const keys = Key; //.map(x => `${fileprefix}/${x}`)
                        const name = files[index].file.name
                        return resolve({ keys, name })
                    })
                }

                const reader = new FileReader()

                reader.onload = () => {
                    const fileData = new Uint8Array(reader.result)
                    //const fileBson = new BSON.Binary(fileData)
                    loadFile(fileData)
                }
                reader.readAsArrayBuffer(files[index].file)
            }
        })
    },
    // s3uploadwithdescription(context, { files, metadata }) {
    //     console.log('files', files);
    //     console.log('metadata', metadata);
    
    //     return new Promise((resolve, reject) => {
    //         if (!files || !files.length) {
    //             return reject(new Error('No Files!'))
    //         }
    //         const credentials = context.rootState.js_report.aws_credentials
    //         if (!credentials) { return reject(new Error('Missing Storage Credentials!')) }
    
    //         const keys = files.map(() => {
    //             return generateHash(); // Generate a unique key for each file.
    //         });
    
    //         const {
    //             key: accessKeyId,
    //             secret: secretAccessKey,
    //             token: sessionToken,
    //             region,
    //             bucket: Bucket,
    //         } = credentials
    //         if (!accessKeyId || !secretAccessKey || !Bucket)
    //             return reject(new Error('Missing Storage Credentials!'))
    //         const options = {
    //             region,
    //             accessKeyId,
    //             secretAccessKey,
    //             sessionToken,
    //         }
    
    //         console.log('options', options)
    //         AWS.config.update(options)
    //         const s3 = new AWS.S3()
    
    //         const webdomain = context.rootGetters["web_domain"];
    //         const fileprefix = Vue.prototype.$MediaPrefix
    //         const { email } = context.rootState.user;
    
    //         // Upload multiple files
    //         for (let index = 0; index < files.length; index++) {
    //             const loadFile = Body => {
    //                 const params = {
    //                     Bucket,
    //                     Key: keys[index],
    //                     Body,
    //                     ContentType: files[index].type,
    //                     ContentDisposition: files[index].name,
    //                     Metadata: {
    //                         webdomain,
    //                         fileprefix,
    //                         email,
    //                         description: metadata[index]?.description || '', // Add the file description from metadata array
    //                     }
    //                 }
    //                 const options = { partSize: 10 * 1024 * 1024, queueSize: 1 };
    //                 console.log('s3Files params', params)
    //                 s3.upload(params, options,  (err, data) => {
    //                     if (err) {
    //                         console.error('s3Files err', err)
    //                         return reject(err)
    //                     }
                      
    //                     console.log('s3 keys', keys)
    //                     const name = files[index].name
    //                     return resolve({ keys, name })
    //                 });

    //                 const param_desc = {
    //                     Bucket,
    //                     Key: keys[index]
    //                 };
    //                 s3.headObject(param_desc, (err, data) => {
    //                     if (err) {
    //                         console.error('Error fetching metadata:', err);
    //                     } else {
    //                         console.log('Metadata:', data);
    //                     }
    //                 });
    //             }
    
    //             const reader = new FileReader()
    
    //             reader.onload = () => {
    //                 const fileData = new Uint8Array(reader.result)
    //                 loadFile(fileData)
    //             }
    //             reader.readAsArrayBuffer(files[index])
    //         }
    //     })
    // },
    // async getMetadataFromS3(context, s3Url) {
    //     try {
    //         const credentials = context.rootState.js_report.aws_credentials;
    //         if (!credentials) {
    //             throw new Error('Missing Storage Credentials!');
    //         }

    //         const { key: accessKeyId, secret: secretAccessKey, token: sessionToken, region,bucket: Bucket } = credentials;

    //         AWS.config.update({
    //             region,
    //             accessKeyId,
    //             secretAccessKey,
    //             sessionToken,
    //         });

    //         const s3 = new AWS.S3();
    //         const url = new URL(s3Url);
    //        // Assuming the bucket name is in the hostname
    //         const file_key = decodeURIComponent(url.pathname.substring(1)); // Remove the leading slash
            
    
            
    //         const params = {
    //             Bucket: Bucket,
    //             Key: file_key,
    //         };
    //         console.log('params--------',params);
    //         const headObject = await s3.headObject(params).promise();
    //         console.log('object -------',headObject);
    //         return headObject.Metadata.description || '';
            
    //     } catch (error) {
    //         console.error('Error fetching metadata from S3:', error);
    //         return {};
    //     }
    // },
    // async  getObjectMetadata(context) {
    //     try {
    //         const credentials = context.rootState.js_report.aws_credentials;
    //         if (!credentials) {
    //             throw new Error('Missing Storage Credentials!');
    //         }
    
    //         const { key: accessKeyId, secret: secretAccessKey, token: sessionToken, region, bucket: Bucket } = credentials;
    
    //         AWS.config.update({
    //             region,
    //             accessKeyId,
    //             secretAccessKey,
    //             sessionToken
    //         });
    
    //         const s3 = new AWS.S3();
    
    //         // Fetching metadata directly using headObject
    //         const params = {
    //             Bucket: 'storage.oms.com',
    //             Key: 'a0eaj30gfywhuw6jpd4m'
    //         };
    
    //         s3.getObject(params, (err, data) => {
    //             if (err) {
    //                 console.error('Error fetching object:', err);
    //             } else {
    //                 console.log('Response Headers:', data.$response.httpResponse.headers); // Access the response headers
    //                 const description = data.Metadata['x-amz-meta-description']; // Metadata keys are in lowercase
    //                 console.log('Description:', description || 'No description set');
    //             }
    //         });
    //     } catch (error) {
    //         console.error('Error fetching metadata from S3:', error);
    //         return {};
    //     }
    // },
    
   
    s3singleUpload(context, files) {
        console.log('files', files)
        const Key = generateHash()
        const credentials = context.rootState.js_report.aws_credentials
        console.log('credentials:', credentials)
        return new Promise((resolve, reject) => {
            if (!credentials)
                return reject(new Error('Missing Storage Credentials!'))
            const {
                key: accessKeyId,
                secret: secretAccessKey,
                token: sessionToken,
                //key_path: Key,
                region,
                bucket: Bucket,
            } = credentials
            if (!accessKeyId || !secretAccessKey || !Bucket)
                return reject(new Error('Missing Storage Credentials!'))
            const options = {
                region,
                accessKeyId,
                secretAccessKey,
                sessionToken,
            }

            console.log('options', options)
            AWS.config.update(options)
            const s3 = new AWS.S3()

            const webdomain = context.rootGetters["web_domain"];
            const fileprefix = Vue.prototype.$MediaPrefix
            const { email } = context.rootState.user;

            const Metadata = {
                webdomain,
                fileprefix,
                email
            }

            if (files && files.length) {
                // upload multiple files
                for (let file of files) {

                    const loadFile = Body => {
                        const params = {
                            Bucket,
                            Key,
                            Body,
                            ContentType: file.type,
                            ContentDisposition: file.name,
                            Metadata
                        }
                        const options = { partSize: 10 * 1024 * 1024, queueSize: 1 };
                        console.log('s3Files params', params)
                        s3.upload(params, options, err => {
                            if (err) {
                                console.error('s3Files err', err)
                                return reject(err)
                            }
                            console.log('s3 Key', Key)
                            return resolve({ key: Key, name: file.name })
                        })
                    }

                    const reader = new FileReader()

                    reader.onload = () => {
                        const fileData = new Uint8Array(reader.result)
                        //const fileBson = new BSON.Binary(fileData)
                        loadFile(fileData)
                    }
                    reader.readAsArrayBuffer(file)

                }
            } else {
                console.log('no files')
            }
        })
    },
    s3singleUploadurl(context, file) {
        console.log('files', file)
        const Key = generateHash()
        const credentials = context.rootState.js_report.aws_credentials
        console.log('credentials:', credentials)
        return new Promise((resolve, reject) => {
            if (!credentials)
                return reject(new Error('Missing Storage Credentials!'))
            const {
                key: accessKeyId,
                secret: secretAccessKey,
                token: sessionToken,
                //key_path: Key,
                region,
                bucket: Bucket,
            } = credentials
            if (!accessKeyId || !secretAccessKey || !Bucket)
                return reject(new Error('Missing Storage Credentials!'))
            const options = {
                region,
                accessKeyId,
                secretAccessKey,
                sessionToken,
            }

            console.log('options', options)
            AWS.config.update(options)
            const s3 = new AWS.S3()

            const webdomain = context.rootGetters["web_domain"];
            const fileprefix = Vue.prototype.$MediaPrefix
            const { email } = context.rootState.user;

            const Metadata = {
                webdomain,
                fileprefix,
                email
            }

            if (file && file.size) {
                console.log('this is ------',file);
                // upload multiple files
                // for (let file of files) {

                    const loadFile = Body => {
                        const params = {
                            Bucket,
                            Key,
                            Body,
                            ContentType: file.type,
                            ContentDisposition: file.name,
                            Metadata
                        }
                        const options = { partSize: 10 * 1024 * 1024, queueSize: 1 };
                        console.log('s3Files params', params)
                        s3.upload(params, options, err => {
                            if (err) {
                                console.error('s3Files err', err)
                                return reject(err)
                            }
                            console.log('s3 Key', Key)
                            return resolve({ key: Key, name: file.name })
                        })
                    }

                    const reader = new FileReader()

                    reader.onload = () => {
                        const fileData = new Uint8Array(reader.result)
                        //const fileBson = new BSON.Binary(fileData)
                        loadFile(fileData)
                    }
                    reader.readAsArrayBuffer(file)

                // }
            } else {
                console.log('no files')
            }
        })
    },
}

const getters = {}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}
